module.exports = __webpack_public_path__ + "static/FoundersGrotesk-RegularItalic-c35b3157a56e2b877db4dd742cae377e.ttf";